import NfcCardRedirect from './NfcCardRedirect';

export default NfcCardRedirect;
